<template>
  <a-row :gutter="24" type="flex" align="middle">
    <!--    <a-col :span="24" style="margin-top: 10px">-->
    <!--      <a-form-model-item-->
    <!--        label="提示"-->
    <!--        :labelCol="{ span: 4, offset: 0 }"-->
    <!--        :wrapperCol="{ span: 20, offset: 0 }"-->
    <!--      >-->
    <!--        <p>请先选择时间</p>-->
    <!--      </a-form-model-item>-->
    <!--    </a-col>-->
    <div style="color: red;margin-left: 13px">
      <span>提示：</span><span>请先选择日期</span>
    </div>
    <a-col :span="24">
      <a-form-model-item
        label="时间"
        :labelCol="{ span: 4, offset: 0 }"
        :wrapperCol="{ span: 20, offset: 0 }"
      >
        <a-select
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          :value="Dateform.Hours"
          style="width: 75px"
          @change="handleChangeHours"
        >
          <a-select-option
            v-for="item in Hourslist"
            :value="item"
            :key="item"
            >{{ item }}</a-select-option
          >
        </a-select>
        <span>&nbsp;&nbsp;时&nbsp;&nbsp;</span>
        <a-select
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          :value="Dateform.Minutes"
          @change="handleChangeMinutes"
          style="width: 75px"
        >
          <a-select-option
            v-for="item in Minuteslist"
            :value="item"
            :key="item"
            >{{ item }}</a-select-option
          >
        </a-select>
        <span>&nbsp;&nbsp;分&nbsp;&nbsp;</span>
      </a-form-model-item>
    </a-col>
    <a-col :span="24" style="text-align: center">
      <a-button type="primary" @click="handleConfirm" :disabled="DisabledBtn"
        >确定</a-button
      >
    </a-col>
  </a-row>
</template>
<script>
import moment from "moment";
// import { mapState } from "vuex";
let Minuteslist = [];
for (let i = 0; i < 60; i++) {
  if (i < 10) {
    let num = "0" + i;
    Minuteslist.push(num);
  } else {
    Minuteslist.push(i + "");
  }
}
export default {
  name: "renderExtraTimeFooter",
  data() {
    return {
      Hourslist: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      Minuteslist,
      Dateform: {
        Hours: "00",
        Minutes: "00"
      },
      DisabledBtn: true,
      form: {}
    };
  },
  props: {
    keyData: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    value: {
      type: String,
      default: ""
    },
    // formVal:{
    //   type: Object,
    //   default: {}
    // },
    defaultVal: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  watch: {
    value: {
      handler: function(newName, oldName) {
        console.log(newName, "newName");
        this.form[this.keyData] = newName;
        if (newName) {
          this.DisabledBtn = false;
        } else {
          this.DisabledBtn = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // ...mapState(["DateYear"])
  },
  mounted() {
    // this.formVal.hasOwnProperty(this.keyData) && this.formVal[this.keyData]
    // this.formVal[this.keyData]
    if (this.value) {
      this.SetDate(this.value);
    } else {
      this.SetDate("");
    }
  },
  methods: {
    SetDate(date) {
      // return;
      if (date) {
        this.form[this.keyData] = date;
        this.Dateform.Hours = moment(date).format("HH");
        this.Dateform.Minutes = moment(date).format("mm");
      } else {
        if (Object.keys(this.defaultVal).length != 0) {
          this.form[this.keyData] =
            moment(new Date()).format("YYYY-MM-DD") +
            " " +
            this.defaultVal.Hours +
            ":" +
            this.defaultVal.Minutes;
          this.Dateform = this.defaultVal;
        }
        // else {
        //   this.Dateform = this.defaultVal;
        // }
      }
    },
    handleChangeHours(val) {
      this.Dateform.Hours = val;
    },
    handleChangeMinutes(val) {
      this.Dateform.Minutes = val;
      this.$forceUpdate();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleConfirm() {
      let date =
        this.form[this.keyData].split(" ")[0] +
        " " +
        this.Dateform.Hours +
        ":" +
        this.Dateform.Minutes;
      this.form[this.keyData] = date;
      const obj = {
        key: this.keyData,
        flag: false,
        date,
        index: this.index
      };
      this.$emit("handleConfirm", obj);
    },
    handleDateslect(val, time) {
      // this.$store.commit("saveCurrDbSource", this.form);
      this.form[this.keyData] = time;
      let obj = {
        key: this.keyData,
        date: this.form[this.keyData]
      };
      if (time) {
        // this.Dateform.Hours = moment(date).format("HH");
        // this.Dateform.Minutes = moment(date).format("mm");
        let date =
          time.split(" ")[0] +
          " " +
          this.Dateform.Hours +
          ":" +
          this.Dateform.Minutes;
        obj = {
          key: this.keyData,
          flag: true,
          date,
          index: this.index
        };
      }
      this.$emit("handleConfirm", obj);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/renderExtraTimeFooter.vue